function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["size", "topOffset"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { getPreset } from '../../Theme/selectors';
function Icon(_ref) {
  var className = _ref.className,
    top = _ref.topOffset,
    renderPaths = _ref.renderPaths,
    onClick = _ref.onClick,
    presetName = _ref.preset,
    viewBox = _ref.viewBox,
    propSize = _ref.size,
    customStyle = _ref.style,
    uiTheme = _ref.uiTheme;
  var size = propSize;
  var style = {
    verticalAlign: 'baseline',
    position: 'relative',
    top: top
  };
  if (presetName) {
    var preset = getPreset(uiTheme, 'icon', presetName);
    var presetSize = preset.size,
      presetTop = preset.topOffset,
      otherStyles = _objectWithoutProperties(preset, _excluded);
    size = preset.size || size;
    style = _objectSpread(_objectSpread({}, style), {}, {
      top: top || presetTop
    }, otherStyles);
  }
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    style: _objectSpread(_objectSpread({}, style), customStyle),
    width: size,
    height: size,
    viewBox: viewBox,
    onClick: onClick
  }, renderPaths(uiTheme));
}
Icon.defaultProps = {
  className: null,
  onClick: null,
  preset: null,
  size: 16,
  style: {},
  topOffset: null,
  uiTheme: {},
  viewBox: '0 0 40 40'
};
export default Icon;